export default __webpack_public_path__ + "static/media/gold_diamond_4.0dba049f.png";